<template>
  <div class="col-12 white-bg">
    <div :class="collapsableHeaderStyle" @click="openCollapsable()">
      <div class="col-10 inline-block py2 px2">
        <slot name="header"/>
      </div>
      <div class="col-2 no-box inline-block justify-end">
        <div
          tabindex="0"
          role="button"
          class="py1 no-box px1 flex xs-justify-center justify-end items-center"
        >
          <i
            class="h1n icon icon-angle-down-icon bold"
            :class="{ 'icon-angle-up-icon': isOpen }"
          ></i>
        </div>
      </div>
    </div>
    <Transition name="fade">
      <div v-if="isOpen" class="collapsable-content" :class="[{ 'overflow-hidden': !isOpen }]">
        <div>
          <slot name="content"/>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>
import { ref, computed } from 'vue';

export default{
  props: {
    collapsableHeader: {
      type: String,
      default: "white-bg"
    },
    collapsableOpen: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object
    }
  },
  setup(props, context) {
    const isOpen = ref(props.collapsableOpen)

    const openCollapsable = () => {
      isOpen.value = !isOpen.value;
      context.emit("openCollapsable", isOpen.value);
      context.emit("openCollapsableData", props.data);
    }

    const collapsableHeaderStyle = computed(() => `block flex h3n col-12 items-center pointer participant-header ${props.collapsableHeader}`)

    return { isOpen, openCollapsable, collapsableHeaderStyle }
  }
}

</script>

<style scoped>
.collapsable-content {
  overflow: hidden;
}

.fade-enter-active {
  transition: all 0.3s ease-out;
}

.fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.fade-enter-from,
.fade-leave-to {
  transform: translateY(20px);
  opacity: 0;
}
</style>